// import $ from "jquery";
// import "slick-carousel";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'bootstrap/js/dist/collapse';

class sliderSwiperStories {
  constructor() {
    this.events();
    this.sliderInit();
    this.collapseInit();
    this.paginationClass = $('.card-slider-01-control .slider__pagination');
  }

  collapseInit() {
    $('.page-id-27592 .text-card-slider button').removeClass('d-none');
    $('.page-id-28538 .text-card-slider button').removeClass('d-none');
    $('.page-id-28503 .text-card-slider button').removeClass('d-none');
    $('.page-id-27156 .text-card-slider button').removeClass('d-none');
    $('.page-id-28884 .text-card-slider button').removeClass('d-none');
    $('.card-slider .textCollapse').click(function () {
      var collapseID = $(this).attr('data-target');

      if ($('.' + collapseID).hasClass('show')) {
        $(this).html('Read more');
        $('.' + collapseID).removeClass('show');
      } else {
        $(this).html('Read less');
        $('.' + collapseID).addClass('show');
      }
    });
  }

  sliderInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    var swiper = new Swiper('.card-slider', {
      slidesPerView: 1,
      spaceBetween: 36,
      grabCursor: true,
      loop: false,
      speed: 500,
      allowTouchMove: true,
      autoHeight: false,
      pagination: {
        el: '.card-slider-01-control .slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.card-slider-01-control .slider__button-next',
        prevEl: '.card-slider-01-control .slider__button-prev',
      },
      on: {
        slideChange: function () {
          $('.fc-collapse').removeClass('show');
          $('.page-id-27592 .text-card-slider button').html('Read more');
          $('.page-id-27156 .text-card-slider button').html('Read more');
          $('.page-id-28884 .text-card-slider button').html('Read more');
        },
      },
    });
  }

  resizeEvents() {
    $(window).on('resize', () => {
      this.sliderInit();
    });
  }

  clickEvents() {}

  events() {
    this.clickEvents();
    this.resizeEvents();
  }
}

export default sliderSwiperStories;
new sliderSwiperStories();
